
<template>
  <li
    :data-within-range="withRange ? '' : null"
    :class="$style.root"
  >
    <pages-editions-parent-nav-link-component
      :entry="entry"
      :label="entry?.title"
    />
  </li>
</template>

<script setup>
const props = defineProps({
  entry: {
    type: Object,
    required: true
  },
  index: Number,
  activeIndex: Number,
  editionsLenght: Number,
  itemsToShow: Number
})

const withRange = computed(() => {
  const range = props?.activeIndex + (props?.itemsToShow - 1)
  if (range < props?.editionsLenght) {
    return props?.index >= props?.activeIndex && props?.index <= range
  } else {
    return props?.index >= (props?.editionsLenght - props?.itemsToShow)
  }
})
</script>

<style module>
.root {
  text-indent: -1ch;
  padding-left: 1ch;
}
</style>
